<template>
  <div>
    <h2 class="text-h6">WP Engine</h2>
    <h3 class="h4 subtitle mb-4">Configure API Access</h3>

    <p class="lead">Please enter in your WP Engine API username and password.</p>
    <p class="lead">
      Can't find your WP Engine API credentials? Here is how -
      <a :href="wpEngineSupportLink" target="_blank">{{ wpEngineSupportLink }}</a>
    </p>

    <c-input v-model="data.userId" label="User Id" type="text" placeholder="User Id" />
    <c-input v-model="data.password" label="Password" type="password" placeholder="Password" />

    <c-button-group>
      <c-button color="primary" :disabled="isSaving" @click="save">Save</c-button>
      <!--      <c-button v-if="showCancelButton" color="secondary" @click="cancelEdit">Reset</c-button>-->
    </c-button-group>
  </div>
</template>

<script>
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'WPEngine',
  props: {
    organisation: Object,
  },

  data() {
    return {
      error: null,
      edit: false,
      isSaving: false,
      data: {
        userId: null,
        password: null,
      },
    };
  },
  computed: {
    wpEngineSupportLink() {
      return 'https://wpengine.com/support/enabling-wp-engine-api/';
    },
  },
  mounted() {
    this.setData();
    this.getInstalls();
  },

  methods: {
    setData() {
      const wpEngine = _.get(this.organisation, 'config.integrations.wpEngine');
      this.data.userId = wpEngine?.userId || '';
    },
    editForm() {
      this.edit = true;
    },
    cancelEdit() {
      this.edit = false;
      this.setData();
    },
    save() {
      if (!this.data.userId || !this.data.password) {
        return;
      }

      this.saving = true;
      this.error = null;

      this.$http
        .put(buildEndpoint('organisation/integrations/wpengine/update'), this.data)
        .then((response) => {
          this.saving = false;
          if (response.data.success) {
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'WP Engine API details successfully',
            });
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error updating WP Engine API details',
            });
          }
        })
        .catch((error) => {
          this.saving = false;
          this.error = error;
        });
    },
    getInstalls() {
      // this.saving = true;
      this.error = null;

      this.$http
        .get(buildEndpoint('organisation/integrations/wpengine/installs/get'))
        .then((response) => {
          this.saving = false;
          if (response.data.success) {
            // this.$store.commit('addSuccessMessage', {
            //   header: 'Success',
            //   message: 'WP Engine API details successfully',
            // });
          } else {
            // this.$store.commit('addErrorMessage', {
            //   header: 'Error updating WP Engine API details',
            // });
          }
        })
        .catch((error) => {
          // this.saving = false;
          // this.error = error;
        });
    },
  },
};
</script>
